<template>
  <v-card :width="width">
    <v-tabs ref="tabs" v-model="graphicSelected" background-color="primaryLight" slider-color="red darken-1" grow>
      <v-tab class="white--text" :key="0">Deforestation rate by distance and variable</v-tab>
      <v-tab class="white--text" :key="1">% Deforestation explained by distance to variable</v-tab>
    </v-tabs>

    <v-tabs-items v-model="graphicSelected">
      <v-tab-item :key="0">
        <v-card>
          <v-card-title>
            <v-switch class="ml-4" v-model="annualStacked" label="Stacked"/>
          </v-card-title>
          <v-card-text align="center">
            <apexchart width="70%" height="600" type="bar" :options="annualChart.options" :series="annualChart.series"></apexchart> <!-- width = 790 -->
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item :key="1">
        <v-card>
          <v-card-title>
            <v-switch class="ml-4" v-model="accumulateStacked" label="Stacked"/>
          </v-card-title>
          <v-card-text align="center">
            <apexchart width="70%" height="600" type="bar" :options="accumulateChart.options" :series="accumulateChart.series"></apexchart>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
export default {
  name: 'Graphics',

  props: {
    width: String,
    graphicsData: {
      type: Object,
      default: () => null
    }
  },

  data: () => ({
    colors: ['#8c3b2f', '#6ebf43', '#6c41c6', '#c3b145', '#ce4cc6', '#5dba84', '#d24873', '#48b3d1', '#db5035', '#434a93', '#c58445', '#8789db', '#55732f', '#7a3171', '#d786bb'],
    graphicSelected: 0,
    annualStacked: false,
    accumulateStacked: true
  }),

  computed: {
    categories () {
      return this.graphicsData ? this.graphicsData.categories : []
    },
    annualData () {
      return this.graphicsData ? this.graphicsData.annualData : []
    },
    accumulateData () {
      return this.graphicsData ? this.graphicsData.accumulateData : []
    },

    annualChart () {
      return {
        options: {
          colors: this.colors,
          chart: {
            id: 'Annual Def Rate',
            stacked: this.annualStacked,
            toolbar: {
              show: true
            },
            zoom: {
              enabled: true
            }
          },
          xaxis: {
            type: 'category',
            categories: this.categories,
            tickPlacement: 'between' // on
          },
          yaxis: {
            labels: {
              formatter: (val) => {
                return val.toFixed(0)
              }
            }
          },
          tooltip: {
            y: {
              formatter: (val, opts) => {
                return Math.round(val * 100) / 100
              }
            }
          },
          dataLabels: {
            formatter: (val, opts) => {
              return Math.round(val * 100) / 100
            }
          },
          plotOptions: {
            bar: {
              columnWidth: '90px',
              dataLabels: {
                orientation: this.annualStacked ? 'horizontal' : 'vertical'
              }
            }
          }
        },
        series: this.annualData
      }
    },

    accumulateChart () {
      return {
        options: {
          colors: this.colors,
          chart: {
            id: 'Accumulate',
            stacked: this.accumulateStacked,
            toolbar: {
              show: true
            },
            zoom: {
              enabled: true
            }
          },
          xaxis: {
            type: 'category',
            categories: this.categories,
            tickPlacement: 'between' // on
          },
          yaxis: {
            max: 100,
            labels: {
              formatter: (val) => {
                return val.toFixed(0) + '%'
              }
            }
          },
          tooltip: {
            y: {
              formatter: (val, opts) => {
                return (Math.round(val * 100) / 100) + '%'
              }
            }
          },
          dataLabels: {
            formatter: (val, opts) => {
              return (Math.round(val * 100) / 100) + '%'
            }
          },
          plotOptions: {
            bar: {
              dataLabels: {
                orientation: this.accumulateStacked ? 'horizontal' : 'vertical'
              }
            }
          }
        },
        series: this.accumulateData
      }
    }
  }
}
</script>

<style scoped>
</style>
